import { Component }     from '@angular/core';
import { MessageToast }  from './message-toast';
import { ToastService } from 'source/app/controls/services/toast/toast-service';

@Component({
    templateUrl: './toast.html'
})
export class ToastComponent {

    constructor(private toast: ToastService) { }

    CreateToast() {
        this.toast.Show(MessageToast);
    }

    CreateException() {
        throw 'Hello World';
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/toast/toast-component.ts